import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54320839"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media" }
const _hoisted_2 = { class: "page-title types" }
const _hoisted_3 = { class: "selector" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "drop"
}
const _hoisted_6 = ["onMousedown"]
const _hoisted_7 = { class: "selector" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "drop"
}
const _hoisted_10 = { class: "lang" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_12 = { class: "versions" }
const _hoisted_13 = ["onMousedown"]
const _hoisted_14 = {
  key: 0,
  class: "not-found c-secondary"
}
const _hoisted_15 = {
  key: 1,
  class: "found-result"
}
const _hoisted_16 = {
  key: 2,
  class: "result"
}
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "source" }
const _hoisted_19 = ["innerHTML", "onClick"]

import search, { State } from '@/store/bible/search';
import contents from '@/views/assets/contents';
import Pagination from '@/views/components/Pagination.vue';
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const data = computed<State>(() => store.state[search.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].bible)
const searchTypes = computed<any>(() => lang.value.search_target)

const types = computed(() => store.getters[search.key('types')])
const vers = computed(() => store.getters[search.key('versions')])
const state = reactive({
    typesVisible: false,
    langsVisible: false,
    showVisible: false,
})
onMounted(() => {
    state.showVisible = true
})
onBeforeUnmount(() => {
    data.value.search = ''
})
function onShowTypes() {
    state.typesVisible = true
    document.onmousedown = function () {
        document.onmousedown = null
        state.typesVisible = false
    }
}
function onType(value: number) {
    router.push({
        name: 'bible-search',
        params: {
            search: data.value.search,
            lang: data.value.lang,
            type: value,
            page: 0
        }
    })
}
function onShowLangs() {
    state.langsVisible = true
    document.onmousedown = function () {
        document.onmousedown = null
        state.langsVisible = false
    }
}
function onLang(value: string) {
    router.push({
        name: 'bible-search',
        params: {
            search: data.value.search,
            lang: value,
            type: data.value.type,
            page: 0
        }
    })
}

function onPageChange(page: number) {
    router.push({
        name: 'bible-search',
        params: {
            search: data.value.search,
            lang: data.value.lang,
            type: data.value.type,
            page: page
        }
    })
}

function onDetail(volume: number, chapter: number, s: number) {
    data.value.target = s
    router.push({
        name: 'bible-detail',
        params: {
            volume: volume + 1,
            chapter: chapter + 1,
            lang: '0',
        },
        query: {
            l: data.value.lang
        },
        hash: '#s' + s
    })
}

function searchText(value: string) {
    try {
        let temp = document.createElement("div");
        temp.innerHTML = value;
        value = temp.innerText || temp.textContent || '';
    } catch (e) {
    }
    return value.replace(new RegExp('(' + data.value.search + ')', 'gi'), '<label class="kw">$1</label>')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "value",
          onClick: onShowTypes
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(searchTypes)[_unref(types)[_unref(data).type].key]), 1),
          _hoisted_4
        ]),
        (_unref(state).typesVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(types), (item, i) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass({ on: _unref(data).type == i }),
                  onMousedown: ($event: any) => (onType(i))
                }, _toDisplayString(_unref(searchTypes)[item.key]), 43, _hoisted_6))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          class: "value",
          onClick: onShowLangs
        }, [
          _createElementVNode("span", null, _toDisplayString(_unref(data).langLabel), 1),
          _hoisted_8
        ]),
        (_unref(state).langsVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(vers), (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("a", null, [
                    _createTextVNode(_toDisplayString(item.lang), 1),
                    _hoisted_11
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.versions, (ver) => {
                      return (_openBlock(), _createElementBlock("a", {
                        onMousedown: ($event: any) => (onLang(ver.key))
                      }, _toDisplayString(ver.label), 41, _hoisted_13))
                    }), 256))
                  ])
                ]))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_unref(data).total == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(lang).search_empty), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(lang).search_result) + "：" + _toDisplayString(_unref(i18).format(_unref(lang).search_result_text, _unref(data).langLabel, _unref(data).total)), 1)),
    (_unref(state).showVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).result, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(contents)[item.volume - 1].name) + " " + _toDisplayString(item.chapter) + ":" + _toDisplayString(item.section), 1),
              _createElementVNode("a", {
                class: "text",
                innerHTML: searchText(item.detail),
                onClick: ($event: any) => (onDetail(item.volume - 1, item.chapter - 1, item.section))
              }, null, 8, _hoisted_19)
            ]))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createVNode(Pagination, {
      total: _unref(data).total,
      page: _unref(data).page,
      size: _unref(data).size,
      onChange: onPageChange
    }, null, 8, ["total", "page", "size"])
  ]))
}
}

})